import React from "react";
import AIIcon from "../../../assets/icons/AIIcon.png";
import NotesAISummarizeModal from "../../patient-lookup/patient-lookup-details/notes-ai-summarize";

import usePatientSearch from "./hooks/usePatientSearch";
import usePatientNotes from "./hooks/usePatientNotes";

import PatientSearchFilters from "./components/PatientSearchFilters";
import PatientResultsTable from "./components/PatientResultsTable";
import NotesTable from "./components/NotesTable";
import WarningModal from "./components/WarningModel";

const PatientNotes: React.FC = () => {
  const patientSearch = usePatientSearch();
  const { selectedPatient } = patientSearch.state;

  const patientNotes = usePatientNotes(selectedPatient);

  return (
    <div className="p-4 pt-2 rounded-lg bg-gray-50 dark:bg-gray-800">
      {/* Header */}
      <div className="mb-3">
        <div className="flex items-center gap-3 mb-2">
          <div className="bg-white p-2 rounded-xl shadow-lg border-2 border-teal-200">
            <img src={AIIcon} alt="AI" className="w-10 h-10" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Patient{" "}
              <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
                Notes
              </span>
            </h1>
            <p className="text-gray-600 text-xs">
              Search for a patient and use AI to summarize or extract todos from
              their notes
            </p>
          </div>
        </div>
      </div>

      {/* Search Filters */}
      <PatientSearchFilters
        state={patientSearch.state}
        actions={patientSearch.actions}
      />

      {/* Patient Results */}
      <PatientResultsTable
        state={patientSearch.state}
        actions={patientSearch.actions}
      />

      {/* Notes Table */}
      {selectedPatient && (
        <NotesTable state={patientNotes.state} actions={patientNotes.actions} />
      )}

      {/* AI Summarize Modal */}
      <NotesAISummarizeModal
        show={patientNotes.state.showAISummarizeModal}
        patientId={selectedPatient?.id || ""}
        selectedNotesIds={patientNotes.state.selectedRows.map((row: any) =>
          String(row.id)
        )}
        todoExtraction={patientNotes.state.todoExtraction}
        onClose={patientNotes.actions.handleCloseAISummarizeModal}
      />

      {/* Warning Modal */}
      <WarningModal
        show={patientNotes.state.showWarningModal}
        selectedCount={patientNotes.state.selectedRows.length}
        todoExtraction={patientNotes.state.todoExtraction}
        onClose={patientNotes.actions.handleCloseWarningModal}
        onContinue={patientNotes.actions.handleContinueWarning}
      />
    </div>
  );
};

export default PatientNotes;